import { ReportInstance } from 'domain/entity/reportInstance';
import getGenericUseCase from 'use-case/genericUseCase';
import ReadReportInstanceCriteria from 'use-case/reportInstance/read/readReportInstanceCriteria';

const readReportInstanceUseCase = getGenericUseCase<ReportInstance, ReadReportInstanceCriteria>((client, criteria) => client(criteria));

export default readReportInstanceUseCase;
